"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_FACILITY_ID = exports.resourceTypeMapper = exports.RESOURCE_TYPES_ARRAY = void 0;
const enums_service_1 = require("../../../services/enums.service");
exports.RESOURCE_TYPES_ARRAY = [enums_service_1.ResourceTypeEnum.INSTRUCTOR, enums_service_1.ResourceTypeEnum.SPACE];
exports.resourceTypeMapper = {
    [enums_service_1.ResourceTypeEnum.INSTRUCTOR]: enums_service_1.ResourceNameTypeEnum.INSTRUCTOR,
    [enums_service_1.ResourceTypeEnum.SPACE]: enums_service_1.ResourceNameTypeEnum.SPACE,
};
exports.DEFAULT_FACILITY_ID = 0;
//# sourceMappingURL=resource.consts.js.map